import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

import PrintOptionsSelector from './PrintOptionsSelector';
import CustomerInfoForm from './CustomerInfoForm';
import { calculatePrintCost } from './utils';

const PreferencesStep = ({ 
  uploadedFiles, 
  totalPages, 
  preferences, 
  setPreferences,
  customerName,
  setCustomerName,
  customerPhone,
  setCustomerPhone,
  customerEmail,
  setCustomerEmail,
  onBack,
  onContinue,
  loading
}) => {
  const cost = calculatePrintCost(totalPages, preferences);

  return (
    <Card className="w-full max-w-md" data-testid="preferences-card">
      <CardHeader>
        <CardTitle className="font-heading text-2xl">Print Preferences</CardTitle>
        <CardDescription>
          {uploadedFiles.length} file{uploadedFiles.length !== 1 ? 's' : ''} • {totalPages} total pages
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <PrintOptionsSelector
          totalPages={totalPages}
          preferences={preferences}
          setPreferences={setPreferences}
        />

        <CustomerInfoForm
          customerName={customerName}
          setCustomerName={setCustomerName}
          customerPhone={customerPhone}
          setCustomerPhone={setCustomerPhone}
          customerEmail={customerEmail}
          setCustomerEmail={setCustomerEmail}
        />

        {/* Cost Display */}
        <div className="bg-secondary rounded-lg p-4">
          <div className="flex justify-between items-center">
            <span className="font-medium">Total Cost:</span>
            <span className="text-2xl font-heading font-bold text-accent" data-testid="total-cost">
              ₹{cost}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="pt-2 flex gap-3">
          <Button
            variant="outline"
            onClick={onBack}
            disabled={loading}
            data-testid="back-to-upload-btn"
            className="flex-1"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Button>
          <Button
            className="btn-primary flex-1"
            onClick={onContinue}
            disabled={loading}
            data-testid="create-job-btn"
          >
            {loading ? 'Creating...' : 'Continue to Payment'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PreferencesStep;
